function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  d: "M16 0H0v15h16zm-1 14H1V4h14zM1 3V1h14v2z"
});

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M3 6h2v2H3zm4 0h2v2H7zm4 0h2v2h-2zm0 4h2v2h-2zm-4 0h2v2H7zm-4 0h2v2H3z"
});

function SvgCalendar(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 16 15"
  }, props), _ref, _ref2);
}

export default "data:image/svg+xml,%3Csvg viewBox='0 0 16 15'%3E %3Cpath d='M16 0H0v15h16zm-1 14H1V4h14zM1 3V1h14v2z' /%3E %3Cpath d='M3 6h2v2H3zm4 0h2v2H7zm4 0h2v2h-2zm0 4h2v2h-2zm-4 0h2v2H7zm-4 0h2v2H3z' /%3E %3C/svg%3E";
export { SvgCalendar as ReactComponent };